import light from "./light";
import dark from "./dark";

export const lightTheme = {
  ...light
};

export const darkTheme = {
  ...dark
};